




















import Vue from 'vue'
import Component from 'vue-class-component';
import {JudgeModel} from '@/models/judge.model';
import ChallengerDetailJudge from '@/components/Challenges/tabs/judges/ChallengerDetailJudge.vue';
import {challengeModule, judgesModule, judgesState} from '@/utils/store-acessor';
import {ChallengeModel} from '@/models/challenge.model';

@Component({
  components: {
    ChallengerDetailJudge
  }
})
export default class ChallengerDetailJudges extends Vue {

  @judgesModule.Getter('judges') judges!: JudgeModel[];
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel | null;

  formatTitle(judges: number): string {
    if (judges > 1) {
      return this.$tc('challenge.judges', 2, {count: judges}).toString();
    } else {
      return this.$tc('challenge.judges', 1, {count: judges}).toString()
    }
  }

  async mounted() {
    if (this.challenge?.id) {
      await judgesState.fetchAll(this.challenge.id)
    }
  }
}
